import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const CreditCardIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 5H4C3.72386 5 3.5 5.22386 3.5 5.5V6H16.5V5.5C16.5 5.22386 16.2761 5 16 5ZM3.5 14.5V8H16.5V14.5C16.5 14.7761 16.2761 15 16 15H4C3.72386 15 3.5 14.7761 3.5 14.5ZM4 3.5C2.89543 3.5 2 4.39543 2 5.5V14.5C2 15.6046 2.89543 16.5 4 16.5H16C17.1046 16.5 18 15.6046 18 14.5V5.5C18 4.39543 17.1046 3.5 16 3.5H4ZM5.5 11.75C5.08579 11.75 4.75 12.0858 4.75 12.5C4.75 12.9142 5.08579 13.25 5.5 13.25H6.5C6.91421 13.25 7.25 12.9142 7.25 12.5C7.25 12.0858 6.91421 11.75 6.5 11.75H5.5ZM8.25 12.5C8.25 12.0858 8.58579 11.75 9 11.75H10C10.4142 11.75 10.75 12.0858 10.75 12.5C10.75 12.9142 10.4142 13.25 10 13.25H9C8.58579 13.25 8.25 12.9142 8.25 12.5ZM12.5 11.75C12.0858 11.75 11.75 12.0858 11.75 12.5C11.75 12.9142 12.0858 13.25 12.5 13.25H13.5C13.9142 13.25 14.25 12.9142 14.25 12.5C14.25 12.0858 13.9142 11.75 13.5 11.75H12.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
